import React from 'react';
import { FeedbackRequestStatus } from '@shared/model/feedback-request';
import { AllAdd, AllSuccess, ArrowsRedo } from '@vtbhome/juicyfront/indexIcon';

export const FEEDBACK_REQUEST_ICON_STATUS_MAP: Record<Exclude<FeedbackRequestStatus, 'canceled'>, React.ReactNode> = {
    created: <AllAdd size='xxs' />,
    progress: <AllSuccess size='xxs' />,
    completed: <ArrowsRedo size='xxs' />,
};

export const FEEDBACK_REQUEST_TEXT_STATUS_MAP: Record<Exclude<FeedbackRequestStatus, 'canceled'>, string> = {
    created: 'Взять в работу',
    progress: 'Закрыть',
    completed: 'Вернуть в работу',
};
